module.exports = __webpack_public_path__ + "img/Woman-3.f5e7410c.svg";